import React from "react";
import { useTranslation } from "react-i18next";
import PageHead from "@/components/PageHead";

export default function TermsPage() {
  const { t } = useTranslation();
  const sections = Array.from({ length: 10 }, (_, i) => i + 1);
  return (
    <>
      <PageHead titleKey="meta.terms.title" descriptionKey="meta.terms.description" />
      <section className="ag-section ag-legal">
        <div className="ag-container ag-legal__inner">
          <span className="ag-eyebrow">{t("nav.terms")}</span>
          <h1 className="ag-h1">{t("terms.title")}</h1>
          <p className="ag-legal__updated">{t("terms.updated")}</p>
          <p className="ag-legal__intro">{t("terms.intro")}</p>
          {sections.map((n) => (
            <div className="ag-legal__section" key={n}>
              <h2>{t(`terms.s${n}Title`)}</h2>
              <p>{t(`terms.s${n}Body`)}</p>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}
